import type { TourDefinition } from '../types';

export const companiesTour: TourDefinition = {
  id: 'companies',
  title: 'Empresas',
  steps: [
    {
      element: '[data-tour="companies-create-btn"]',
      popover: {
        title: 'Nova Empresa',
        description:
          'Cadastre novas empresas e associe leads a elas.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="companies-search"]',
      popover: {
        title: 'Busca de Empresas',
        description:
          'Encontre empresas por nome, setor ou localização.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="companies-filters"]',
      popover: {
        title: 'Filtros',
        description:
          'Filtre por setor, tamanho, responsável e outros critérios.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="companies-table"]',
      popover: {
        title: 'Tabela de Empresas',
        description:
          'Veja todas as empresas com informações de leads vinculados, valor total e último contato.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
